module.exports = __webpack_public_path__ + "img/common-file-text-remove.13abaaf5.svg";